// src/app/writing-tools/writing-tools.service.ts
import { Injectable } from '@angular/core';
import { HttpClient }    from '@angular/common/http';
import { Observable }    from 'rxjs';
import { WritingToolsDto } from '../../../../../../api/src/integrations/vml-openai-gateway/vml-openai-gateway.dto';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class WritingToolsService {
	private api = 'https://vyc-openai-api-gateway-3513fc87d34a.herokuapp.com/writing-tools';

	constructor(private http: HttpClient) {}

	// applyTool(dto: WritingToolsDto): Observable<{ status: string, data: string }> {
	// 	return this.http.post<{ status: string, data: string }>(this.api, dto);
	// }

	applyTool(dto: WritingToolsDto): Observable<{ status: string, data: string }> {
		return this.http.post<{ status: string, data: string }>(`${environment.apiUrl}/integrations/writing-tools`, dto);
	}
}
